"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutation = exports.post = exports.get = exports.subscribe = exports.query = exports.initialize = void 0;
var aws_amplify_1 = require("aws-amplify");
var fields_1 = require("@sendpayments/graphql/fields");
var mutations = __importStar(require("@sendpayments/graphql/mutations"));
var queries = __importStar(require("@sendpayments/graphql/queries"));
var subscriptions = __importStar(require("@sendpayments/graphql/subscriptions"));
var logger_1 = require("../logger");
var isLoggerEnabled;
var isInitialized;
var isAppOnline = true;
var queriesEntries = Object.entries(queries);
var mutationsEntries = Object.entries(mutations);
var subscriptionsEntries = Object.entries(subscriptions);
var ConnectionError = /** @class */ (function (_super) {
    __extends(ConnectionError, _super);
    function ConnectionError() {
        var _this = _super.call(this, 'There is no connection right now, please try again later...') || this;
        _this.name = 'ConnectionError';
        return _this;
    }
    return ConnectionError;
}(Error));
var log = {
    error: function (method, err, ex) {
        if (isLoggerEnabled) {
            logger_1.logger.error("@sendpayments/js-utils/services/endpoint - Method: ".concat(method), "Error: ".concat(err), ex);
        }
    },
    info: function (method, info, data) {
        if (isLoggerEnabled) {
            logger_1.logger.info("@sendpayments/js-utils/services/endpoint - Method: ".concat(method), "Info: ".concat(info), data);
        }
    },
};
// we can now implement caching if we want
var initialize = function (_a) {
    var _b = _a.useLogging, useLogging = _b === void 0 ? false : _b;
    if (!isInitialized) {
        isInitialized = true;
        isLoggerEnabled = useLogging;
        window.addEventListener('online', function () {
            isAppOnline = true;
        });
        window.addEventListener('offline', function () {
            isAppOnline = false;
        });
    }
};
exports.initialize = initialize;
// These are not being used at all, commenting it out because not sure if we will need it one day or not
// export const getQueryF = (queryName) => {
//   if (!queryName || !queries[queryName]) {
//     throw new Error('must be present and defined in `@send-graphql/queries` or be a new function');
//   }
//
//   return queries[queryName];
// };
//
// export const getMutationF = (mutationName) => {
//   if (!mutationName || !mutations[mutationName]) {
//     throw new Error('must be present and defined in `@send-graphql/mutations` or be a new function');
//   }
//
//   return mutations[mutationName];
// };
var getName = function (func, entries) {
    var key = entries.find(function (_a) {
        var f = _a[1];
        return f === func;
    })[0];
    if (key) {
        return key;
    }
    return undefined;
};
var query = function (queryF, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.params, params = _c === void 0 ? {} : _c, projection = _b.projection;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryName, queryObj, data, ex_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    queryName = getName(queryF, queriesEntries) || 'newQuery';
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    if (!queryF) {
                        throw new Error('must be present and defined in `@sendpayments/graphql/queries` or be a new function');
                    }
                    log.info('query', "getting the query name");
                    log.info('query', "query name", queryName);
                    log.info('query', "querying for ".concat(queryName, " with params:"), params);
                    if (!isAppOnline) {
                        throw new ConnectionError();
                    }
                    queryObj = void 0;
                    if (Object.keys(params).length > 0) {
                        queryObj = (0, fields_1.graphqlOperationEx)(queryF, __assign({}, params), projection);
                    }
                    else {
                        queryObj = (0, aws_amplify_1.graphqlOperation)(queryF, projection);
                    }
                    log.info('query', "querying for ".concat(queryName, " to execute:"), queryObj);
                    return [4 /*yield*/, aws_amplify_1.API.graphql(queryObj)];
                case 2:
                    data = (_d.sent()).data;
                    log.info('query', "querying for ".concat(queryName, " with result:"), data);
                    return [2 /*return*/, data && data[queryName]];
                case 3:
                    ex_1 = _d.sent();
                    log.error('query', "Error while querying for ".concat(queryName, " with ex:"), ex_1);
                    throw ex_1;
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.query = query;
// TODO review this to only subscribe once to each subscription
var subscribe = function (subscriptionF, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.params, params = _c === void 0 ? {} : _c;
    return function (onSubscription, onError) {
        var subscriptionName = getName(subscriptionF, subscriptionsEntries);
        try {
            if (!subscriptionF) {
                throw new Error('must be present and defined in `@sendpayments/graphql/subscriptions`');
            }
            if (!onSubscription) {
                throw new Error('subscribe must be present param onSubscription');
            }
            var subscriptionObj = (0, fields_1.graphqlOperationEx)(subscriptionF, params);
            log.info('subscribe', "subscribing for ".concat(subscriptionName, " to execute:"), subscriptionObj);
            if (!isAppOnline) {
                throw new ConnectionError();
            }
            var subObject_1 = aws_amplify_1.API.graphql(subscriptionObj).subscribe({
                next: function (subResult) {
                    log.info('subscribe', "subscription for ".concat(subscriptionName, " with result:"), subResult);
                    var data = subResult && subResult.value && subResult.value.data && subResult.value.data[[subscriptionName]];
                    onSubscription(data);
                },
                error: function (err) {
                    log.error('subscribe', "subscription for ".concat(subscriptionName, " throw an error"), err);
                    if (onError) {
                        onError(err);
                    }
                },
            });
            return function () {
                log.info('subscribe', "REMOVING subscription for ".concat(subscriptionName, " to execute"));
                subObject_1.unsubscribe();
            };
        }
        catch (ex) {
            log.error('subscribe', "Error while querying for ".concat(subscriptionName, " with ex:"), ex);
            throw ex;
        }
    };
};
exports.subscribe = subscribe;
var get = function (url, _a, apiName) {
    var _b = _a === void 0 ? {} : _a, data = _b.data;
    if (apiName === void 0) { apiName = 'SendApi'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var session, params, response, ex_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    if (!url) {
                        throw new Error('url need to be present');
                    }
                    return [4 /*yield*/, aws_amplify_1.Auth.currentSession()];
                case 1:
                    session = _c.sent();
                    if (!session || !session.idToken || !session.idToken.jwtToken) {
                        throw new Error('User not authenticated');
                    }
                    log.info('get', "Executing get with url ".concat(url, " and data:"), data);
                    if (!isAppOnline) {
                        throw new ConnectionError();
                    }
                    params = {
                        headers: {
                            Token: session.idToken.jwtToken,
                        },
                    };
                    if (data) {
                        params.queryStringParameters = __assign({}, data);
                    }
                    return [4 /*yield*/, aws_amplify_1.API.get(apiName, url, params)];
                case 2:
                    response = _c.sent();
                    log.info('get', "Result get from ".concat(apiName, " with url ").concat(url, " response:"), response);
                    return [2 /*return*/, response];
                case 3:
                    ex_2 = _c.sent();
                    log.error('get', "Error while executing get to ".concat(url), ex_2);
                    throw ex_2;
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.get = get;
var post = function (url, _a, apiName) {
    var _b = _a === void 0 ? {} : _a, data = _b.data;
    if (apiName === void 0) { apiName = 'SendApi'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var session, params, response, ex_3;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    if (!url) {
                        throw new Error('url need to be present');
                    }
                    return [4 /*yield*/, aws_amplify_1.Auth.currentSession()];
                case 1:
                    session = _c.sent();
                    if (!session || !session.idToken || !session.idToken.jwtToken) {
                        throw new Error('User not authenticated');
                    }
                    log.info('post', "Executing post to ".concat(apiName, " with url ").concat(url, " and data:"), data);
                    if (!isAppOnline) {
                        throw new ConnectionError();
                    }
                    params = {
                        headers: {
                            Token: session.idToken.jwtToken,
                        },
                        body: Object.keys(data).length > 0 ? data : undefined,
                    };
                    return [4 /*yield*/, aws_amplify_1.API.post(apiName, url, params)];
                case 2:
                    response = _c.sent();
                    log.info('post', "Result post to ".concat(apiName, " with url ").concat(url, " response:"), response);
                    return [2 /*return*/, response];
                case 3:
                    ex_3 = _c.sent();
                    log.error('post', "Error while executing post to ".concat(url), ex_3);
                    throw ex_3;
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.post = post;
var mutation = function (mutationF, _a) {
    var _b = _a.data, dataToSend = _b === void 0 ? {} : _b, projection = _a.projection;
    return __awaiter(void 0, void 0, void 0, function () {
        var mutationName, mutationObj, data, ex_4;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    mutationName = getName(mutationF, mutationsEntries) || 'newMutation';
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    if (!mutationF) {
                        throw new Error('must be present and defined in `@sendpayments/graphql/mutations`');
                    }
                    log.info('mutation', "mutation for ".concat(mutationName, " with params:"), dataToSend);
                    if (!isAppOnline) {
                        throw new ConnectionError();
                    }
                    mutationObj = (0, fields_1.graphqlOperationEx)(mutationF, {
                        input: dataToSend,
                    }, projection);
                    log.info('mutation', "mutation with ".concat(mutationName, " to execute:"), mutationObj);
                    return [4 /*yield*/, aws_amplify_1.API.graphql(mutationObj)];
                case 2:
                    data = (_c.sent()).data;
                    log.info('mutation', "mutation with ".concat(mutationName, " with result:"), data);
                    return [2 /*return*/, data && data[mutationName]];
                case 3:
                    ex_4 = _c.sent();
                    log.error('mutation', "Error while mutating for ".concat(mutationName, " with ex:"), ex_4);
                    throw ex_4;
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.mutation = mutation;
//# sourceMappingURL=index.js.map